import type { ReactNode } from "react"
import { alpha } from "@mui/material/styles"
import { Box, Container } from "@mui/material"
import { makeStyles } from "tss-react/mui"

type Props = Readonly<{
    children: ReactNode
}>

const useStyles = makeStyles()((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: theme.spacing(6, 3),
    },
    card: {
        background: theme.palette.common.white,
        borderRadius: "1rem",
        padding: "2.5rem",
        maxWidth: "32rem",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "1.5rem",
        boxShadow: `0 0 10px 0 ${alpha(theme.palette.common.black, 0.15)}`,
    },
}))

export function TakeawayResultCard({ children }: Props) {
    const { classes } = useStyles()

    return (
        <Container className={classes.container}>
            <Box className={classes.card}>{children}</Box>
        </Container>
    )
}
